import { clearDesignationCacheForElement } from '../components/DesignationField'

interface NodeWithBaseElementId {
    baseElementId?: string
}

/**
 * Clears designation cache for all removed/deleted nodes.
 * Call this when PT/Family/Assembly content is removed from project.
 */
export const clearDesignationCacheForRemovedNodes = (
    removedNodes: NodeWithBaseElementId[],
    deletedNodes?: NodeWithBaseElementId[] | null
) => {
    const allNodes = [...removedNodes, ...(deletedNodes || [])]
    allNodes.forEach((node) => {
        if (node.baseElementId) {
            clearDesignationCacheForElement(node.baseElementId)
        }
    })
}
